<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div class="tablet flex justify-center px-4">
      <div class="relative flex flex-col items-start rounded bg-white p-6">
        <img
          class="absolute right-4 top-4 h-4 w-4 cursor-pointer"
          src="@/assets/close-icon.svg"
          alt="cose icon"
          @click="$emit('close')"
        />

        <h3 class="header-text">
          {{ modalTitle }}
        </h3>
        <p class="mb-5 text-left text-body-color">
          {{ modalSubtitle }}
        </p>
        <div
          class="flex w-full flex-col md:ml-auto md:flex-row md:flex-row-reverse md:gap-x-2"
        >
          <button-main @click="$emit('submit')">
            {{ buttonText }}
          </button-main>
          <button-main
            variant="secondary"
            class="mt-3 md:mt-0"
            @click="$emit('close')"
          >
            Cancel
          </button-main>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'Dispatch Request Modal',
  components: {
    Modal,
    ButtonMain,
  },
  props: {
    visible: Boolean,
    type: String,
  },
  emits: ['close', 'submit'],
  computed: {
    modalTitle() {
      return this.type === 'accept' ? 'Accept Request?' : 'Decline Request?';
    },
    modalSubtitle() {
      return this.type === 'accept'
        ? 'Accepting this request will add this dispatch service to your company’s account and enable them to onboard with Brokers on your behalf.'
        : 'This dispatch service will not be added to your company’s account.';
    },
    buttonText() {
      return this.type === 'accept'
        ? 'Yes, Accept Request'
        : 'Yes, Decline Request';
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 768px) {
  .tablet {
    width: 500px;
    /* height: 250px; */
  }
}

.header-text {
  font-size: 26px;
  @apply mb-4 text-dark-blue;
}
</style>
